import * as React from 'react';
import {
  FilterList,
  FilterLiveSearch,
  FilterListItem,
} from 'react-admin';
import { Box } from '@material-ui/core';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';

const LessonListFilter = (props) => {
  const [divisions, setDivisions] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/cms/divisions`)
      .then(response => response.json())
      .then(data => {
        setDivisions(data);
      })
  }, []);

  var xray = []
  var challange = []
  var content = []
  var treiners = []
  var others = []

  divisions.forEach(e => {
    if (e.id == 11 || e.id == 12 || e.id == 13) {
      xray.push(e)
    } else if (e.id == 15 || e.id == 17 || e.id == 16 || e.id == 18) {
      challange.push(e)
    }else if (e. id == 10 || e. id == 21 || e. id == 22 || e.id == 14 || e.id == 19 || e.id == 20 ) {
      others.push(e)
    }else {
      treiners.push(e)
    }
  });

  treiners.forEach(e => {
    if (e.name == 'Condução') {
      e.name ='1 - Condução'
    }
    if (e.name == 'Bola Parada') {
      e.name = '2 - Bola Parada'
    }
    if (e.name == 'Finalização') {
      e.name ='3 - Finalização'
    }
    if (e.name == 'Domínio e Controle') {
      e.name = '4 - Domínio'
    }
    if (e.name == 'Passe') {
      e.name = '5 - Passe'
    }
    if (e.name == 'Drible') {
      e.name = '6 - Drible'
    }
    if (e.name == 'Aquecendo') {
      e.name = '7 - Aquecimento'
    }
    if (e.name == 'Fique em forma') {
      e.name = '8 - Fique em forma'
    }
    if (e.name == 'Truques') {
      e.name = '9 - Truques'
    }
  })
  
  treiners.sort(function(x, y) {
    let a = x.name
    let b = y.name
    return a == b ? 0 : a > b ? 1 : -1
  })

  let showSearch = true;
  if (props.showSearch !== undefined) {
    showSearch = props.showSearch;
  }

  return (
    <Box width="15em" order="-1" marginRight="1em">
      {showSearch ? <FilterLiveSearch /> : undefined}

      {/* <FilterList label="Divisões" icon={<LocalOfferIcon />}>
        {divisions.length &&
          divisions.map(div => (
            <FilterListItem
              key={div.id}
              label={div.name}
              value={{ division: div.id }}
            />
          ))
        }
      </FilterList> */}

      <FilterList label="Treinos" >
        {treiners.length &&
          treiners.map(div => (
            <FilterListItem
              key={div.id}
              label={div.name}
              value={{ division: div.id }}
            />
          ))
        }
      </FilterList>

      <FilterList label="Super-desafio" >
        {challange.length &&
          challange.map(div => (
            <FilterListItem
              key={div.id}
              label={div.name}
              value={{ division: div.id }}
            />
          ))
        }
      </FilterList>

      <FilterList label="Raio-X" >
        {xray.length &&
          xray.map(div => (
            <FilterListItem
              key={div.id}
              label={div.name}
              value={{ division: div.id }}
            />
          ))
        }
      </FilterList>

      <FilterList label="Outros" >
        {others.length &&
          others.map(div => (
            <FilterListItem
              key={div.id}
              label={div.name}
              value={{ division: div.id }}
            />
          ))
        }
      </FilterList>

    </Box>
  );
};

export default LessonListFilter;